module.exports = __webpack_public_path__ + "static/sec1-4f4b2be0767d794321f6e62a9e37885a.png";